window.portalModule.directive "cancelDisclaimer", ['$log', ($log) ->
  restrict: "E"
  scope:
    feedItem: '='

  link: (scope, element, attrs) ->

  templateUrl: 'portal/appointments/modals/cancel/cancel-disclaimer/cancel-disclaimer-directive-template.html'
]